module.exports = __webpack_public_path__ + "static/img/draw_area.6f1abaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/draw_area.png
// module id = 529
// module chunks = 1